import styled, { css } from 'styled-components';
import {
  Segment as SegmentLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

import ClampLines from 'react-clamp-lines';

import {
  Grid as SemanticGrid,
  Icon as SemanticIcon,
  Image as SemanticImage,
} from 'semantic-ui-react';

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContainerDelete = styled.div`
  padding: 20px 40px 0 10px;
`;

export const DeleteText = styled(TextLayoutComponent)`
  color: red;
  cursor: pointer;
`;

export const Image = styled(SemanticImage)`
  &.ui.image {
    height: 20px;
    width: 20px;
  }
`;

export const ImageContainer = styled.div`
  ${({ isTreeTest, isSurvey, theme }) => css`
    background: ${theme.color.cardColor};
    padding: 5px 15px;
    border-radius: 30px;
    cursor: pointer;
    height: 50px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;

    ${isTreeTest && `
      background: ${theme.color.treeColor};
    `};
    ${isSurvey && `
      background: ${theme.color.surveyColor};
    `};
  `}
`;

export const CardRow = styled(SemanticGrid.Row)`
  &&& {
    padding: 7.5px 0;
    display: flex;
    width: 95%;
    align-items: center;
    justify-content: space-between;
    margin-left: 0px;

    :last-child {
      margin-bottom: 40px;
    }
  }
`;

export const Icon = styled(SemanticIcon)`
  cursor: pointer;
  font-size: 1em !important;
  min-width: 60px;
`;

export const Card = styled(SegmentLayoutComponent)`
  &&& {
    flex-direction: column;
    min-height: 72px;
    padding: 0;
    text-align: center;
    width: 100%;
  }
`;

export const ContainerVideo = styled.div`
  display: flex;
  height: 70px;
  justify-content: center;
  margin: 7.5px 0;
  margin-bottom: auto;
  width: 50px;
  margin-left: 5px;
`;

export const VideoIcon = styled(SemanticIcon)`
  color: #477AE9;
  cursor: pointer;
  display: flex;
  font-size: 40px !important;
  margin: auto !important;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CustomClampLines = styled(ClampLines)`
  display: flex;
  padding: 0;
`;

export const CardHeader = styled.div`
  align-items: center;
  display: flex;
  height: 70px;

  :hover {
    cursor: pointer;
  }
`;

export const UserAvatar = styled.div`
  display: flex;
  width: 60px;
`;

export const Arrow = styled.div`
  display: flex;
  width: 60px;
`;

export const NewVideoText = styled(TextLayoutComponent)`
  font-family: Roboto;
  font-weight: 500;
  font-size: 11px;
  letter-spacing: 1px;
  color: #164775;
  background-color: #E4F3FF;
  border: 1px solid #CDE8FE;
  border-radius: 3px;
  padding: 5px;
`;

export const Spacer = styled.div`
  width: 39px;
`;

export const ContainerNewText = styled.div`
  align-items: center;
  display: flex;
  height: 25px;
  width: 40px;
  justify-content: center;
  margin-bottom: auto;
  margin-left: -50px;
  position: absolute;
`;

export const ContainerColumn = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex || 1)};
  justify-content: ${({ isLast }) => (isLast ? 'right' : '')};
`;

export const ColumnText = styled(TextLayoutComponent.Span).attrs(() => ({
  fontSize: '16px',
}))`
    margin-right: 30px;
    width: 100%;
  `;
